module.exports = __webpack_public_path__ + "img/synoptic.90bff657.png";